import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import DocumentClassificationSelect from "../../utils-components/document-classification-select";
import { mapActions } from "vuex";
import { CREATE_DOCUMENT_CLASSIFICATIONS, CREATE_DOCUMENT_TYPE } from "../../../store/documents-actions";
import ManageDocumentTypeModal from "./manage-document-types-modal";
import { values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClassificationSelectContainer",
  components: {
    DocumentClassificationSelect,
    ManageDocumentTypeModal
  },
  props: {
    applicationId: {
      type: [String, Number],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    persistSelection: {
      type: Boolean,
      default: false
    },
    loaderPosition: {
      type: String,
      default: "left"
    },
    allowManage: {
      type: Boolean,
      default: true
    },
    parentId: {
      type: String,
      default: "classification-select-container"
    },
    id: {
      type: String,
      default: "classification-select"
    }
  },
  data() {
    return {
      creating: false,
      value: {
        id: "",
        documentType: ""
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("DocumentsStore", ["documentTypes"])), mapGetters("DocumentsStore", ["DOCUMENT_TYPES_SELECT", "DOCUMENT_TYPE_DESCRIPTION"])), {}, {
    documentTypesData() {
      return values(this.documentTypes.byId);
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [CREATE_DOCUMENT_CLASSIFICATIONS, CREATE_DOCUMENT_TYPE])), {}, {
    async handleClassificationSelection({
      documentType,
      id
    }) {
      this.creating = true;
      if (this.persistSelection) this.value = {
        documentType,
        id
      };
      const documentRequestIds = await this.CREATE_DOCUMENT_CLASSIFICATIONS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        documentRequests: [{
          documentType,
          description: id === "no-results-btn" ? "" : this.DOCUMENT_TYPE_DESCRIPTION(id)
        }]
      });
      if ((documentRequestIds == null ? void 0 : documentRequestIds.length) > 0) {
        this.$emit("created", {
          documentRequestId: documentRequestIds[0].documentRequestId,
          documentType,
          id
        });
        this.value = this.persistSelection ? _objectSpread(_objectSpread({}, this.value), {}, {
          documentRequestId: documentRequestIds[0].documentRequestId
        }) : {};
      }
      this.creating = false;
    },
    openManageDocumentTypesModal() {
      this.$refs.manageDocumentTypes.show();
    }
  })
});